import { useSearchParams } from "react-router-dom";

export const useSearchParam = (param: string): string => {
  const [searchParams] = useSearchParams();
  const value = searchParams.get(param);

  return value ? decodeURIComponent(value) : "";
};
